import React, { useState, useEffect } from "react";
import zongIcon from "../../assets/images/zong/login.svg";
import { View, ViewOff, Renew } from "@carbon/icons-react";
import axios from "axios";
import { url } from "../../Constant";
import { toast } from "react-toastify";
import { ValidateEmail } from "../../Utils/regexFunctions";
import { customEncrypt, encrypt, key } from "../../Utils/EncryptionDescryption";
import Cookies from "js-cookie";
import ReCAPTCHA from "react-google-recaptcha";
import { useNavigate } from "react-router-dom";
// import { useHistory } from "react-router-dom";

const GoogleReCaptchaStyle = {
  display: "block",
  alignItems: "center",
};

const Login = () => {
  const [viewPassword, setViewPassword] = useState(false);
  const [loader, setLoader] = useState(false);
  const [emailError, setEmailError] = useState("");
  const [errorEnable, setErrorEnable] = useState(false);
  const [recaptchaValue, setRecaptchaValue] = useState("");
  const [captchaValue, setCaptchaValue] = useState("");
  // const [captchaValueapi, setCaptchaValueApi] = useState([]);
  const [captchaValueapi, setCaptchaValueApi] = useState([]); // Initialize captchaValueapi as an empty string

  const navigate = useNavigate();
  // const [generatedCaptcha, setGeneratedCaptcha] = useState(
  //   generateRandomCaptcha()
  // );

  const [error, setError] = useState(false);

  // function generateRandomCaptcha() {
  //   const captchaChars =
  //     "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  //   const captchaLength = 6;
  //   let captcha = "";
  //   for (let i = 0; i < captchaLength; i++) {
  //     const randomIndex = Math.floor(Math.random() * captchaChars.length);
  //     captcha += captchaChars[randomIndex];
  //   }
  //   return captcha;
  // }

  // const refreshCaptcha = () => {
  //   setGeneratedCaptcha(generateRandomCaptcha());
  //   setCaptchaValue("");
  //   setError(false); // Reset the error when refreshing the CAPTCHA.
  // };

  const handleCaptchaChange = (e) => {
    const inputValue = e.target.value;
    setCaptchaValueApi(inputValue);
    setError(inputValue !== setCaptchaValueApi);
  };

  const [user, setUser] = useState({
    email: "",
    password: "",
    role: "",
    recaptcha: "",
    captcha: "",
  });

  // const history = useHistory();

  const handleViewPassword = () => {
    setViewPassword(!viewPassword);
  };

  const dataStore = (message) => {
    const encryptedText = encrypt(message, key);

    Cookies.set(
      "YUTETOLPBG-ASY1BSBD#!ASDNMlPOS--_AWQQWyADIURYBDSF092B34BSDSEWEWFELPOWD",
      encryptedText,
      {
        expires: 1,
        secure: true,
        // httpOnly: true,
        sameSite: "Lax",
      }
    );
  };

  
  const onChangeRecp = (value) => {
    // console.log("Captcha value:", value);
    setRecaptchaValue(value);
  };
  const handleLogin = (e) => {
    setErrorEnable(true);
    e.preventDefault();
    setLoader(true);
    if (
      user.email !== "" &&
      user.password !== "" &&
      user.role !== "" &&
      user.captcha !== "" &&
      emailError === "Valid Email Address"
      // recaptchaValue !== ""
      // captchaValue === generatedCaptcha
    ) {
      axios
        .post(url + "auth/signin", {
          email: user.email,
          password: user.password,
          role: user.role,
          captcha: user.captcha,
          recaptcha: "6LcmokEoAAAAAKNts0j1o2_YXxa_lBk4w-ekZNmA-aW",
        })
        .then(
          (result) => {
            // console.log(result)
            if (result.data.status === true) {
              if (
                result.data.code === 200 &&
                result.data.data.length !== 0 &&
                result.data.message !== "Unauthorized"
              ) {
                if (user.role === "1") {
                  const message = `loginStatus:1;role:${sessionStorage.getItem(
                    "role"
                  )};user_id:${result.data.data.user_id};email:${
                    result.data.data.email
                  };mobile_number:${result.data.data.mobile_number};user_name:${
                    result.data.data.user_name
                  };vpbx_id:null;company_name:null;address:null;ntn:null;work_number:null;password:null;diodid:null;template_name:null;package_id:null;package_activation_datetime:null;package_inactivation_datetime:null;bolt_on_id:null;bolt_on_activation_datetime:null;bolt_on_inactivation_datetime:null;bundle_id:null;bundle_datetime:null;inbound_recording:null;outbound_recording:null;extension_recording:null;bundle_inactivation_datetime:null;status:null;created_on:null;updated_on:null;id:null;name:null;defaultuser:null;extension_number:null;email_id:null;extension_name:null;token:${
                    result.data.access_token
                  };is_templete:null;
                    is_feedback:null;call_initiated:null;OC_status:null`;
                  dataStore(message);
                  // console.log("umair id", message);
                } else if (user.role === "2") {
                  const message = `loginStatus:1;role:${sessionStorage.getItem(
                    "role"
                  )};user_id:null;email:${
                    result.data.data.email
                  };mobile_number:${result.data.data.mobile_number};user_name:${
                    result.data.data.user_name
                  };vpbx_id:${result.data.data.vpbx_id};company_name:${
                    result.data.data.company_name
                  };address:${result.data.data.address};ntn:${
                    result.data.data.ntn
                  };work_number:${result.data.data.work_number};password:${
                    result.data.data.password
                  };diodid:${result.data.data.diodid};template_name${
                    result.data.data.template_name
                  };package_id:${
                    result.data.data.package_id
                  };package_activation_datetime:${
                    result.data.data.package_activation_datetime
                  };package_inactivation_datetime:${
                    result.data.data.package_inactivation_datetime
                  };bolt_on_id:${
                    result.data.data.bolt_on_id
                  };bolt_on_activation_datetime:${
                    result.data.data.bolt_on_activation_datetime
                  };bolt_on_inactivation_datetime:${
                    result.data.data.bolt_on_inactivation_datetime
                  };bundle_id:${result.data.data.bundle_id};bundle_datetime:${
                    result.data.data.bundle_datetime
                  };inbound_recording:${
                    result.data.data.inbound_recording
                  };outbound_recording:${
                    result.data.data.outbound_recording
                  };extension_recording:${
                    result.data.data.extension_recording
                  };bundle_inactivation_datetime:${
                    result.data.data.bundle_inactivation_datetime
                  };status:${result.data.data.status};created_on:${
                    result.data.data.created_on
                  };updated_on:${
                    result.data.data.updated_on
                  };id:null;name:null;defaultuser:null;extension_number:null;email_id:null;extension_name:null;token:${
                    result.data.access_token
                  };is_templete:${result.data.data.is_templete};
                    is_feedback:${result.data.data.is_feedback};call_initiated:${result.data.data.call_initiated};OC_status:${result.data.data.OC_status}`;

                  dataStore(message);
                  // console.log("umair id", message);
                } else if (user.role === "3") {
                  const message = `loginStatus:1;role:${sessionStorage.getItem(
                    "role"
                  )};user_id:null;email:null;mobile_number:null;user_name:${
                    result.data.data.user_name
                  };vpbx_id:${
                    result.data.data.vpbx_id
                  };company_name:null;address:null;ntn:null;work_number:null;password:null;diodid:null;template_name:null;package_id:null;package_activation_datetime:null;package_inactivation_datetime:null;bolt_on_id:null;bolt_on_activation_datetime:null;bolt_on_inactivation_datetime:null;bundle_id:null;bundle_datetime:null;inbound_recording:null;outbound_recording:null;extension_recording:null;bundle_inactivation_datetime:null;status:null;created_on:null;updated_on:null;id:${
                    result.data.data.id
                  };name:${result.data.data.name};defaultuser:${
                    result.data.data.defaultuser
                  };extension_number:${
                    result.data.data.extension_number
                  };email_id:${result.data.data.email_id};extension_name:${
                    result.data.data.extension_name
                  };token:${
                    result.data.access_token
                  };is_templete:${result.data.data.is_templete};is_feedback:null;call_initiated:null;OC_status:null`;
                  dataStore(message);
                  localStorage.setItem(
                    "sdh4AAhdsgsjd660-sd",
                    customEncrypt(
                      JSON.stringify(result.data.access_permission),
                      key
                    )
                  );
                }
                setLoader(false);
                toast.success("Login Successfully !", {
                  position: toast.POSITION.TOP_RIGHT,
                  autoClose: 1000,
                });
                setTimeout(() => {
                  window.location.href = "/welcome";
                  sessionStorage.clear();
                }, 1500);
                setErrorEnable(false);
              } else {
                toast.error(result.data.message, {
                  position: toast.POSITION.TOP_RIGHT,
                });
                captureValue();
                setUser({
                  ...user,
                  captcha: "",
                });
                setErrorEnable(false);
                setLoader(false);
              }
            }
          },
          (error) => {
            if (error.message === "Network Error") {
              toast.error("Network Error", {
                position: toast.POSITION.TOP_RIGHT,
              });
            }
            setErrorEnable(false);
            setLoader(false);
          }
        );
    } else {
      setLoader(false);
    }
  };
  const handleEmailValidation = (e) => {
    var Email = ValidateEmail(e.target.value);
    if (Email === "Invalid Email") {
      setEmailError("Invalid Email Address");
    } else {
      setEmailError("Valid Email Address");
    }
  };

  useEffect(() => {
    captureValue();
  }, []);

  const captureValue = () => {
    axios.post(url + "auth/refreshCaptcha").then(
      (response) => {
        // console.log('umair', response.data.captcha);
        if (response.data.code === 200) {
          setCaptchaValueApi(response.data.captcha);
        }
      },
      (error) => {
        console.log(error);
      }
    );
  };

  return (
    <>
      <div className="loginWrp">
        <div uk-grid="" className="uk-grid uk-grid-small">
          <div className="uk-width-1-2">
            <div className="imgwrp loginHeading">
              <img src={zongIcon} alt="" />
              <p>
                Transform your communication <br />
                with ZONG CAP
              </p>
            </div>
          </div>
          <div className="uk-width-1-2">
            <div className="formwrp">
              <form onSubmit={(e) => handleLogin(e)}>
                <div className="loginHeading">
                  <h2>Login</h2>
                </div>
                <div uk-gird="">
                  <div className="uk-width-1-1">
                    <div className="inputField">
                      <input
                        type="text"
                        placeholder="Email or mobile number"
                        onChange={(e) => {
                          setUser({ ...user, email: e.target.value });
                          handleEmailValidation(e);
                        }}
                      />
                    </div>
                  </div>
                  {user.email === "" && errorEnable && (
                    <div className="uk-width-1-1 errors">Email is Required</div>
                  )}
                  {user.email !== "" &&
                    emailError !== "Valid Email Address" && (
                      <div className="uk-width-1-1 errors">
                        Invalid Email Address
                      </div>
                    )}
                  <div className="uk-width-1-1">
                    <div className="inputField">
                      <input
                        type={viewPassword ? "text" : "password"}
                        placeholder="Password"
                        onChange={(e) =>
                          setUser({ ...user, password: e.target.value })
                        }
                      />

                      {viewPassword ? (
                        <ViewOff
                          className="viewIcon"
                          onClick={handleViewPassword}
                        />
                      ) : (
                        <View
                          className="viewIcon"
                          onClick={handleViewPassword}
                        />
                      )}
                    </div>
                  </div>
                  {user.password === "" && errorEnable && (
                    <div className="uk-width-1-1 errors">
                      Password is Required
                    </div>
                  )}
                  <div className="uk-width-1-1">
                    <div className="inputField">
                      <select
                        onChange={(e) => {
                          setUser({ ...user, role: e.target.value });
                          // localStorage.setItem("role", e.target.value);
                          sessionStorage.setItem("role", e.target.value);
                        }}
                      >
                        <option value="" selected>
                          Select your role
                        </option>
                        <option value="1">Super Admin</option>
                        <option value="2">VPBX Admin</option>
                        <option value="3">VPBX User</option>
                      </select>
                    </div>
                  </div>
                  {user.role === "" && errorEnable && (
                    <div className="uk-width-1-1 errors">
                      PLease select role
                    </div>
                  )}

                  {/* <div className="uk-width-1-1">
                    <div className="inputField">
                      <ReCAPTCHA
                        sitekey="6LcmokEoAAAAAKNts0j_YXxa_lBk4w-ekZNmA-aW"
                        onChange={onChangeRecp}
                      />
                    </div>
                  </div>
                  {user.recaptcha === "" && errorEnable && (
                    <div className="uk-width-1-1 errors">
                      ReCAPTCHA is Required
                    </div>
                  )}  */}

                  <div className="uk-width-1-1">
                    <div>
                      <div
                      // style={{
                      //   display: "flex",
                      //   justifyContent: "space-between",
                      // }}
                      >
                        <div className="captcha-code">
                          {captchaValueapi && (
                            <span
                              style={{
                                fontFamily: "Arial, sans-serif",
                                fontSize: "20px",
                                letterSpacing: "20px",
                                backgroundColor: "#f2f2f2",
                                color: "#000",
                                padding: "5px 10px",
                                border: "1px solid #ccc",
                                borderRadius: "5px",
                                userSelect: "none", // Prevent text selection
                                cursor: "not-allowed", // Change cursor on hover to indicate non-selectable
                                width: "100%",
                                marginBottom: "10px",
                                display: "block",
                                textAlign: "center",
                              }}
                            >
                              {captchaValueapi}
                            </span>
                            // <img src={captchaValueapi} alt={captchaValueapi} />
                          )}
                        </div>

                        {/* <div className="captcha-refresh">
                          <button variant="light" onClick={refreshCaptcha}>
                            <Renew />
                          </button>
                        </div> */}
                      </div>
                      <div className="captcha-field inputField">
                        <input
                          type="text"
                          // id='captchaValue'
                          placeholder="Enter below CAPTCHA value"
                          value={user.captcha}
                          onChange={(e) =>
                            setUser({ ...user, captcha: e.target.value })
                          }
                        />
                      </div>

                      {error && (
                        <div className=" uk-width-1-1 errors error-message">
                          CAPTCHA does not match
                        </div>
                      )}
                    </div>
                  </div>
                  {user.captcha === "" && errorEnable && (
                    <div className="uk-width-1-1 errors">
                      CAPTCHA is Required
                    </div>
                  )}
                  <div className="uk-width-1-1">
                    <div className="txtwrp">
                      <span>
                        <a href="/">Privacy Policy </a> and{" "}
                        <a href="/">Terms of Service</a> apply .
                      </span>
                    </div>
                  </div>
                  <div className="uk-width-1-1">
                    <div className="btnwrp">
                      <div className="forgetBtn">
                        {/* <a href="/forgot-password">Forgot password?</a> */}
                      </div>
                      <div className="loginBtn uk-width-1-1 uk-flex uk-flex-between">
                        <button onClick={() => navigate("/signup")} className="btn-2" type="button" disabled={loader ? true : false}>
                          Sign up
                        </button>
                        <button className="btn-1" type="submit" disabled={loader ? true : false}>
                          {loader ? (
                            <div uk-spinner="" className="loader">
                              Continue
                            </div>
                          ) : (
                            "Log in"
                          )}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
